import { combineReducers } from "redux";

export const initState = {
  navbarState: "HOME",
  selectedJob: null,
  isUserComingFromCreateJob: false,
  isUserComingFromViewJob: false,
};

// reducers
const navbarStateChangeReducer = (state = initState, action) => {
  switch (action.type) {
    case "NAVBAR_STATE_CHANGE": {
      return {
        ...state,
        navbarState: action.payload,
      };
    }
    case "UPDATE_SELECTED_JOB": {
      return {
        ...state,
        selectedJob: action.payload,
      };
    }
    case "UPDATE_USER_FROM_CREATE_JOB": {
      return {
        ...state,
        isUserComingFromCreateJob: action.payload,
      };
    }
    case "UPDATE_USER_FROM_VIEW_JOB": {
      return {
        ...state,
        isUserComingFromViewJob: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

// combined reducer
export const reducer = combineReducers({
  navbarStateChangeReducer,
});
